import { render, staticRenderFns } from "./MessageDropdown.vue?vue&type=template&id=3772fda5"
import script from "./MessageDropdown.vue?vue&type=script&lang=js"
export * from "./MessageDropdown.vue?vue&type=script&lang=js"
import style0 from "./MessageDropdown.vue?vue&type=style&index=0&id=3772fda5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3772fda5')) {
      api.createRecord('3772fda5', component.options)
    } else {
      api.reload('3772fda5', component.options)
    }
    module.hot.accept("./MessageDropdown.vue?vue&type=template&id=3772fda5", function () {
      api.rerender('3772fda5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-navbar/components/dropdowns/MessageDropdown.vue"
export default component.exports